<script>
import button from "@/mixins/toolBar/button";
import toastrs from "@/mixins/toastrs";
// import axios from "axios";
import axios from '@/libs/axios'

export default {
  name: "InferenceButton",
  mixins: [button, toastrs],
  props: {
    image_id: {
      required: false,
      type: [String, Number],
      default: null
    },
  },
  data() {
    return {
      name: "Inference",
      icon: "fa-object-group"
    };
  },
  computed: {
    isApiOnlyUser() {
      return this.$store.getters['user/isApiOnlyUser'];
    },
    isProductionEnv() {
      return this.$store.state.info.apiKeyEnv === 'live';
    },
    shouldBlockWebFeatures() {
      return this.isApiOnlyUser && this.isProductionEnv;
    }
  },
  methods: {
    execute() {
      // External API 사용자 제한 검사
      if (this.shouldBlockWebFeatures) {
        this.$toastr.error(
          "API 계정은 프로덕션 환경에서 웹 Inference를 사용할 수 없습니다. External API를 이용해주세요.",
          "Inference Blocked"
        );
        return;
      }
      this.$forceUpdate()

      let options = {
        progressBar: true,
        positionClass: "toast-bottom-left",
        timeOut: 6000
      };
      let options2 = {
        progressBar: true,
        positionClass: "toast-bottom-left",
        timeOut: 5000,
      };
      this.$toastr.info("Started", "Inference", options);
      const imageId = this.image_id || (this.$parent.image && this.$parent.image.id);

      if (imageId == null) {
        this.$toastr.error("Image ID is null", "Inference", options2);
        return;
      }

      axios
        .post(`/api/resultAI/inference/?original_id=${imageId}`, {
          headers: {"Content-Type": "multipart/form-data"}
        })
        .then( response => {
          // this.axiosReqestSuccess("Inference", response.data.message);
          this.$toastr.info(response.data.message, "Inference", options2);
          this.$emit("inference-started", { imageId, response: response.data });
        })
        .catch( error => {
          // this.axiosReqestError("Inference", error.response.data.message);
          this.$toastr.info(error.response.data.message, "Inference", options2);
        })
        // .finally(()=>{
        //   setTimeout(() => this.$router.go(), 5000);
        // })
    }
  }
};
</script>
